import { combineReducers } from "redux";

import airlinesProductivityReducer from "./airlines_productivity/reducers";
import airlinesReducer from "./airlines/reducers";
import alertsReducer from "./alerts/reducers";
import auctionReducer from "./auction/reducers";
import { authPersistedState } from "./auth/persisted";
import authReducer from "./auth/reducers";
import bookingReducer from "./bookings/reducers";
import clicksReducer from "./clicks/reducers";
import conversionsReducer from "./conversions/reducers";
import { currencyPersistedState } from "./currencies/persisted";
import currenciesReducer from "./currencies/reducers";
import debugReducer from "./debug/reducers";
import faqReducer from "./faq/reducers";
import feedbacksReducer from "./feedbacks/reducers";
import gateTesterReducer from "./gate_tester/reducers";
import gatesReducer from "./gates/reducers";
import hostsReducer from "./hosts/reducers";
import integrationErrorsReducer from "./integration_errors/reducers";
import marketsReducer from "./markets/reducers";
import reportsReducer from "./reports/reducers";
import routesReducer from "./routes/reducers";
import userReducer from "./user/reducers";
import Widgets from "./widgets/reducers";

const RootReducer = combineReducers({
  Widgets,
  Auth: authReducer,
  User: userReducer,
  Bookings: bookingReducer,
  Gates: gatesReducer,
  GateTester: gateTesterReducer,
  Hosts: hostsReducer,
  Clicks: clicksReducer,
  Markets: marketsReducer,
  Currencies: currenciesReducer,
  Conversions: conversionsReducer,
  Auction: auctionReducer,
  Routes: routesReducer,
  Airlines: airlinesReducer,
  AirlinesProductivity: airlinesProductivityReducer,
  Alerts: alertsReducer,
  Debug: debugReducer,
  Reports: reportsReducer,
  Feedbacks: feedbacksReducer,
  IntegrationErrors: integrationErrorsReducer,
  FAQ: faqReducer,
});

export const persistedState = () => ({
  Auth: authPersistedState(),
  Currencies: currencyPersistedState(),
});

export type RootState = ReturnType<typeof RootReducer>;
export default RootReducer;
